<template>
  <div class="form-card form-card--bare">
    <div class="form-card__body">
      <div class="form-card__field">
        <label class="form-card__label" for="check-numero">Número</label>
        <input
          id="check-numero"
          v-model="check.number"
          type="number"
          class="form-control"
          placeholder="N° de cheque"
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="check-emisor">Nombre del emisor</label>
        <input
          id="check-emisor"
          v-model.trim="check.name"
          type="text"
          class="form-control"
          placeholder="Nombre del emisor"
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="check-cuit">CUIT</label>
        <input
          id="check-cuit"
          v-model="check.cuit"
          type="number"
          class="form-control"
          placeholder="CUIT"
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="check-banco">Banco</label>
        <sucursales-bancarias
          id="check-banco"
          v-model="check.bank_name"
        />
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="check-tipo">Tipo</label>
        <select
          id="check-tipo"
          v-model="check.check_kind"
          class="form-control"
        >
          <option v-for="opt in checkKindOptions" :key="opt.value" :value="opt.value">
            {{ opt.text }}
          </option>
        </select>
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="check-monto">Monto</label>
        <input
          id="check-monto"
          v-model="check.amount"
          type="number"
          step="0.01"
          class="form-control"
          placeholder="Monto"
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="check-fecha-emision">Fecha de emisión</label>
        <input
          id="check-fecha-emision"
          v-model="check.date_issue"
          type="date"
          class="form-control"
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="check-fecha-cobro">Fecha de cobro</label>
        <input
          id="check-fecha-cobro"
          v-model="check.date_due"
          type="date"
          class="form-control"
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="check-notas">Notas</label>
        <textarea
          id="check-notas"
          v-model="check.note"
          class="form-control"
          placeholder="Notas..."
          rows="2"
        />
      </div>
    </div>

    <div class="form-card__footer">
      <button type="button" class="form-card__btn form-card__btn--primary" @click="saveCheck">
        <i class="bi bi-check-lg"></i>
        Guardar cheque
      </button>
    </div>
  </div>
</template>

<script>
import formatDateMixin from "../../mixins/formatDateMixin";
import SucursalesBancarias from "./../sub-components/sucursalesBancarias.vue";
import { CHECK_KIND_OPTIONS } from "../../constants/checkKind";

export default {
  components: {
    SucursalesBancarias,
  },
  mixins: [formatDateMixin],
  props: ["checkId", "showNewBtn"],
  data() {
    return {
      modo: 'nuevo',
      checkKindOptions: CHECK_KIND_OPTIONS,
      check: {
        number: null,
        name: '',
        cuit: null,
        bank_name: '',
        date_issue: '',
        date_due: '',
        amount: null,
        note: '',
        check_kind: 'fisico',
      },
      emptycheck: {
        number: null,
        name: '',
        cuit: null,
        bank_name: '',
        date_issue: '',
        date_due: '',
        amount: null,
        note: '',
        check_kind: 'fisico',
      },
    };
  },
  watch: {
    checkId(value) {
      if (value != null) {
        this.getCheck(value);
      } else {
        this.resetForm();
      }
    },
  },
  mounted() {
    this.resetForm();
    if (this.checkId != null) {
      this.getCheck(this.checkId);
    }
  },
  methods: {
    validateForm() {
      if (this.check.number === null || isNaN(this.check.number)) {
        alert('Debe ingresar un número de cheque');
        return false;
      }
      if (this.check.name === null || this.check.name === '') {
        alert('Debe ingresar un nombre');
        return false;
      }
      if (this.check.cuit === null || isNaN(this.check.cuit)) {
        alert('Debe ingresar un nro de CUIT');
        return false;
      }
      if (this.check.bank_name == null || this.check.bank_name === '') {
        alert('Debe ingresar el nombre del banco');
        return false;
      }
      if (this.check.date_due == null || this.check.date_due === '') {
        alert('Debe ingresar la fecha de cobro');
        return false;
      }
      if (this.check.date_issue == null || this.check.date_issue === '') {
        alert('Debe ingresar la fecha de emisión');
        return false;
      }
      if (this.check.amount == null || isNaN(this.check.amount)) {
        alert('Ingrese el monto');
        return false;
      }
      return true;
    },
    getCheck(id) {
      this.modo = 'editar';
      this.$http.get('/api/funds/checks/get/' + id).then((response) => {
        this.check = response.data.data;
        this.check.date_issue = this.formatoFecha2Date(this.check.date_issue);
        this.check.date_due = this.formatoFecha2Date(this.check.date_due);
      });
    },
    saveCheck() {
      if (!this.validateForm()) return;
      if (this.check.id != null) {
        const data = {
          ...this.check,
          date_issue: this.formatoDate2Fecha(this.check.date_issue),
          date_due: this.formatoDate2Fecha(this.check.date_due),
        };
        this.$http.post('/api/funds/checks/edit/' + this.check.id, data).then(() => {
          this.resetForm();
          this.$emit('confirmsave');
        });
      } else {
        this.$http.post('/api/funds/checks/add', this.check).then(() => {
          this.resetForm();
          this.$emit('confirmsave');
        });
      }
    },
    resetForm() {
      this.check = Object.assign({}, this.emptycheck);
      this.$emit('reset-id');
    },
  },
};
</script>
